import { EEventStatisticsCodes } from 'widgets/event-statistics/EventStatistics.types'

export const EVENT_STATISTIC_BLOCK_LIVE_TIME_LIST = [
  EEventStatisticsCodes.CurrentTime,
  EEventStatisticsCodes.RemainingTime,
  EEventStatisticsCodes.MatchPhase
]
